
import React, { useEffect,useState } from "react";
import Chart from "react-apexcharts";
import { Box, Typography, Select, MenuItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
// import { fetchServiceDashboardData } from "../../../redux/slices/serviceDashboardSlice";
import { fetchServiceDashboardData } from "../../../../redux/reducers/serviceDashboardSlice";
const RevenueByServiceChart = () => {
  const dispatch = useDispatch();
  const { revenuebyTop5, loading } = useSelector((state) => state.serviceDashboard);
  const [timeRange, setTimeRange] = useState("6m");
  const [chartData, setChartData] = useState({
    series: [],
    categories: [],
  });
    const mapTimeRangeToKey = (range) => {
    const keyMap = {
      "3m": "last3months",
      "6m": "last6months",
      "9m": "last9months",
      "12m": "last12months",
    };
    return keyMap[range] || "last6months";
  };



  useEffect(() => {
    dispatch(fetchServiceDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!revenuebyTop5 || !revenuebyTop5[mapTimeRangeToKey(timeRange)]) return;

    const data = revenuebyTop5[mapTimeRangeToKey(timeRange)];

    setChartData({
      categories: data.map((item) => item.serviceName),
      series: [{ name: "Revenue", data: data.map((item) => item.total) }],
    });
  }, [revenuebyTop5, timeRange]);

  const options = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: {
        columnWidth: "40%",
        borderRadius: 4,
        distributed: true,
      },
    },
    colors: ["#0052CC", "#1ABC7B", "#FFA800", "#FF4C96", "#9B51E0"],
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: chartData.categories,
      labels: { style: { fontSize: "13px" } },
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
          if (val >= 1000) return `${(val / 1000).toFixed(1)}k`;
          return val.toString();
        },
      },
    },
    grid: { strokeDashArray: 4 },
    tooltip: {
      y: {
        formatter: (val) => `₹ ${val.toLocaleString("en-IN")}`,
      },
    },
  };

  return (
    <Box sx={{
      backgroundColor: "#fff",
      borderRadius: 2,
      p: 3,
      boxShadow: 1,
      maxWidth: 800,
      margin: "auto",
    }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="subtitle1" fontWeight={600}>
          Revenue by Service (Top 5)
        </Typography>
        <Select
          size="small"
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          sx={{ fontSize: 14 }}
        >
          <MenuItem value="3m">Last 3 months</MenuItem>
          <MenuItem value="6m">Last 6 months</MenuItem>
          <MenuItem value="9m">Last 9 months</MenuItem>
          <MenuItem value="12m">Last 12 months</MenuItem>
        </Select>
      </Box>

      <Chart options={options} series={chartData.series} type="bar" height={300} />
    </Box>
  );
};

export default RevenueByServiceChart;